import { AlucioAVCheck, MODE_TYPE } from '@alucio/video';
import React, { useState } from 'react';
import { ImageBackground, StyleSheet } from 'react-native';
import { Stack } from '@alucio/lux-ui';
import colors from '@alucio/lux-ui/lib/theming/themes/alucio/colors';
const styles = StyleSheet.create({
    container: {
        width: '100vw',
        height: '100vh',
    },
});
export const withAVChecker = (Component) => (props) => {
    const [AVCheck, setAVCheck] = useState({ showDialog: true, deviceSettings: undefined });
    if (props.mode !== MODE_TYPE.HOST)
        return React.createElement(Component, Object.assign({}, props));
    else if (props.mode === MODE_TYPE.HOST &&
        !AVCheck.showDialog)
        return React.createElement(Component, Object.assign({}, props, { deviceSettings: AVCheck.deviceSettings }));
    return (React.createElement(React.Fragment, null, AVCheck.showDialog && React.createElement(Stack, null,
        React.createElement(Stack.Layer, { style: styles.container },
            React.createElement(ImageBackground, { source: props.background, style: { flex: 1, backgroundColor: 'black' }, imageStyle: { opacity: 0.5 } })),
        React.createElement(Stack.Layer, { style: {
                width: '100vw',
                height: '100vh',
                backgroundColor: colors['color-dark-transparent-1000'],
            } },
            React.createElement(AlucioAVCheck, { meetingName: `${props.hostName} Room`, submitLabel: 'Start Meeting', attendeeName: 'Host', onJoinMeeting: (e) => {
                    props.onJoinMeeting && props.onJoinMeeting();
                    setAVCheck({
                        deviceSettings: e.deviceSettings,
                        showDialog: false,
                    });
                }, mobileView: false, deniedMediaImage: props.deniedMediaImage, audioFiles: props.audioFiles, showDisclaimer: false })))));
};
//# sourceMappingURL=WithVideoChecker.js.map